import { Elements } from '@stripe/react-stripe-js'
import { createBrowserHistory } from 'history'
import { Provider } from 'mobx-react'
import 'promise.prototype.finally/auto'
import { createRoot } from './utils/react-shim'

import totemClient from './mobx-rest-jsonapi-client'

// import { CrashErrorBoundary } from '@totem/base'

export default function renderMobxRestApp({
  RootComponent,
  basename,
  stripePromise,
}) {
  const browserHistory = createBrowserHistory({ basename: basename })

  const rootElement = document.getElementById('root')

  if (!rootElement) return null

  const rootComponent = stripePromise ? (
    <Elements stripe={stripePromise}>
      <RootComponent history={browserHistory} />
    </Elements>
  ) : (
    <RootComponent history={browserHistory} />
  )

  if (rootElement) {
    const root = createRoot(rootElement)
    root.render(
      <Provider client={totemClient}>
        {rootComponent}
        {/* <CrashErrorBoundary>{rootComponent}</CrashErrorBoundary> */}
      </Provider>,
    )
  }
}
